import { animate, timeline as timeline2, stagger } from "//home-cooks.co.uk/cdn/shop/t/143/assets/vendor.min.js?v=161072099565793977701707219051";
(function (window, k) {
    // https://home-cooks.co.uk/pages/referral-landing?user_id=6388020576308&variant_id=41422214791220
    $(document).ready(async function() {
        var pathname = window.location.pathname;
        var referralAccountEmail;
        var createAccountId;

        // Check if Referral Landing Page
        if(pathname.includes("/pages/referral-landing")) {
            // Get URL params
            var userId = getQueryParam('user_id');
            var variantId = getQueryParam('variant_id');
            
            $("#check_if_customer").on("click", async function() {
                var $form = $(".customer-verify");

                // Pixel event - 'Claim Free Dish'
                await createPixelEvent("Claim Free Dish");

                if (!$form[0].checkValidity()) {
                    $form[0].reportValidity();
                    return;
                }
                var $button = $(this);
                var $contentElement = $button.find('div');
                var $animationElement = $button.find('.button__loader');

                timeline2([
                    [$contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                    [$animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                  ]);
                animate($animationElement.children().get(), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
                
                var inputEmail = $("#email_verification").val();
                var isCustomer = await checkIfCustomerExists(inputEmail);

                if(isCustomer != 0) {
                    $(".customer-referral-error").show();
                    timeline2([
                        [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                        [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                      ]);
                    $contentElement.html('✖');
                    setTimeout(function(){
                        $contentElement.html('Claim FREE Dish');
                        $(".customer-referral-error").hide();
                    }, 5000)
                } else {
                    timeline2([
                        [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                        [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                      ]);
                      $contentElement.html('✔');
                    setTimeout(function(){
                        $(".customer-verify").hide();
                        $("#referral_customer_email").val(inputEmail);
                        $(".referral-order").show();
                    }, 2000)
                }
            })

            $("#referral_create_account").on("click", async function() {
                var $form = $(".referral-order");

                if (!$form[0].checkValidity()) {
                    $form[0].reportValidity();
                    return;
                }
                var $button = $(this);
                var $contentElement = $button.find('div');
                var $animationElement = $button.find('.button__loader');

                timeline2([
                    [$contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                    [$animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                  ]);
                animate($animationElement.children().get(), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
            
                referralAccountEmail = $("#referral_customer_email").val();
                var referralAccountPassword = $("#referral_customer_password").val();
                createAccountId = await createCustomerAccount(referralAccountEmail, referralAccountPassword);
            
                if(createAccountId != 0) {
                    timeline2([
                        [$animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                        [$contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                      ]);
                    $contentElement.html('Account Created ✔');

                    setTimeout(function(){
                        $(".referral-content").hide();
                        $(".referral_order_completion").show();
                        $('html, body').animate({
                            scrollTop: 0
                        }, 'slow');
                    }, 2000)
                }
            })

            $("#order_referral").on("click", async function() {
                var $form = $("#create_referral_order_form");

                // Pixel event - 'Order Now'
                await createPixelEvent("Order Now");

                if (!$form[0].checkValidity()) {
                    $form[0].reportValidity();
                    return;
                }

                var $button = $(this);
                var $contentElement = $button.find('div');
                var $animationElement = $button.find('.button__loader');

                timeline2([
                    [$contentElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
                    [$animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
                  ]);
                animate($animationElement.children().get(), { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });

                var orderData = {
                    firstName: $('#first_name_referral').val(),
                    lastName: $('#last_name_referral').val(),
                    address: $('#address_referral').val(),
                    city: $('#city_referral').val(),
                    postCode: $('#post_code_referral').val(),
                    phone: $('#phone_referral').val()
                };

                var orderComplete = await createOrder(referralAccountEmail, createAccountId, variantId, orderData, userId);

                if(orderComplete != 0) {
                    setTimeout(function(){
                        $(".referral_order_completion").hide();
                        $(".success_referral_order").show();
                        $('html, body').animate({
                            scrollTop: 0
                        }, 'slow');
                    }, 2000)
                }
            })
            
            // Fill variables with correct data
            if(userId && variantId) {
                await getGifterName(userId);
                var productId = await getProductId(variantId);
                if (productId) {
                    await getProductInformation(productId);
                }
            }

            async function getGifterName(id) {
                makeRequestAPI(`admin/api/2024-04/customers/${id}.json`, 'GET')
                    .then(data => {
                        $("#gifter_name").text(data.customer.first_name);
                    })
                    .catch(error => {
                        console.error('Erro ao obter informações do cliente:', error);
                    });
            }

            async function getProductId(id) {
                return makeRequestAPI(`admin/api/2024-01/variants/${id}.json`, 'GET')
                    .then(data => {
                        return data.variant.product_id;
                    })
                    .catch(error => {
                        console.error('Erro ao obter informações do cliente:', error);
                    });
            }

            async function getProductInformation(id) {
                makeRequestAPI(`admin/api/2024-01/products/${id}.json`, 'GET')
                    .then(data => {
                        $(".product_name").text(data.product.title);
                        $("#vendor_name").text(data.product.vendor);
                        $(".referral_product_image").attr("src", data.product.image.src)
                        $(".product_price").text(shopCurrencySymbolReferral + data.product.variants[0].price);
                        
                        $("#referral_template .swiper-loader").hide();
                        $("#referral_template .referral-content").show();
                    })
                    .catch(error => {
                        console.error('Erro ao obter informações do cliente:', error);
                    });
            }

            async function checkIfCustomerExists(email) {
                try {
                    const data = await makeRequestAPI(`admin/api/2024-04/customers/search.json?query=email:${email}`, 'GET');
                    return data.customers.length;
                } catch (error) {
                    console.error('Erro ao obter informações do cliente:', error);
                    return 0;
                }
            }

            async function createCustomerAccount(email, password) {
                try {
                    const bodyData = {
                        "customer":{
                           "email":email,
                           "verified_email":true,
                           "password":password,
                           "password_confirmation":password,
                           "send_email_welcome":false
                        }
                    };
                    const data = await makeRequestAPI('admin/api/2024-01/customers.json', 'POST', bodyData);
                    return data.customer.id;
                } catch (error) {
                    console.error('Error creating customer:', error);
                    return 0;
                }
            }

            async function createOrder(email, customerId, variantId, orderData, referrerId) {
                try {
                    const bodyData = {
                        "order": {
                          "email": email,
                          "fulfillment_status": null,
                          "send_receipt": false,
                          "send_fulfillment_receipt": false,
                          "line_items": [
                            {
                              "variant_id": variantId,
                              "quantity": 1,
                              "price": 0
                            }
                          ],
                          "customer": {
                            "id": customerId
                          },
                          "shipping_address": {
                            "first_name": orderData.firstName,
                            "last_name": orderData.lastName,
                            "address1": orderData.address,
                            "phone": orderData.phone,
                            "city": orderData.city,
                            "country": "United Kingdom",
                            "zip": orderData.postCode
                          },
                          "note" : referrerId
                        }
                    };                 

                    const data = await makeRequestAPI('admin/api/2024-01/orders.json', 'POST', bodyData);
                    return data.order.length;
                } catch (error) {
                    console.error('Error creating order:', error);
                    return 0;
                }
            }

            async function createPixelEvent(eventName) {
                try {
                    const bodyData = {
                        "event_name" : eventName
                    };
                    const data = await makeEnvoyApiRequest('pixel-event', 'POST', bodyData);
                    return data;
                } catch (error) {
                    console.error('Error in Pixel Event', error);
                    return 0;
                }
            }

            function getQueryParam(name) {
                const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                if (results == null) {
                    return null;
                }

                return decodeURIComponent(results[1]) || 0;
            }

            function makeRequestAPI(endpoint, method, data = null) {
                const url = `https://dev.escolhadigital.com/Homecooks/shopify-api.php?endpoint=${endpoint}&method=${method}`;
                
                var options = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };

                if (method === 'POST' && data) {
                    options.method = 'POST';
                    options.body = JSON.stringify(data);
                }

                return fetch(url, options)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Erro ao fazer requisição para a API');
                        }
                        return response.json();
                    })
                    .then(data => {
                        return data;
                    })
                    .catch(error => {
                        console.error('Erro:', error);
                        return null;
                    });
            }

            function makeEnvoyApiRequest(endpoint, method, data = null) {
                const url = `https://dev.escolhadigital.com/Homecooks/envoy-api.php?endpoint=${endpoint}&method=${method}`;
                        
                var options = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
        
                if (method === 'POST' && data) {
                    options.method = 'POST';
                    options.body = JSON.stringify(data);
                }
        
                return fetch(url, options)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Erro ao fazer requisição para a API');
                        }
                        return response.json();
                    })
                    .then(data => {
                        return data;
                    })
                    .catch(error => {
                        console.error('Erro:', error);
                        return null;
                    });
            }
        }
    });
})(window);